import { Amount } from '~/components/in-year-budget-requests/constants/amounts';
import { CurrencyRate } from '~/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/iybr-new-project-collapsible/create-iybr-form-utils';

/** Cost table cell values are mEUR (typically under 10); convert to EUR with × 1M × FX. */
export type BudgetToBeApprovedMeur = {
    'MTP+1': number;
    'MTP+2': number;
    'MTP+3': number;
    ff?: number;
    previousYears?: number;
};

export type BudgetToBeApprovedUpdate = {
    mtpPlus1Meur: number;
    totalEur: number;
};

function fxRate(currencyRate: CurrencyRate | undefined, rateKey: string): number {
    if (!currencyRate) {
        return 1;
    }
    const value = (currencyRate as CurrencyRate & Partial<Record<string, number>>)[rateKey];
    return typeof value === 'number' ? value : currencyRate.forecast;
}

export function meurToEur(meur: number, currencyRate: CurrencyRate | undefined, rateKey: string): number {
    return meur * Amount.ONE_MILLION * fxRate(currencyRate, rateKey);
}

/** Overall “budget to be approved” row total in EUR (sum of MTP+1…+3, plus FF/previous years for projects). */
export function totalBudgetToBeApprovedEur(
    values: BudgetToBeApprovedMeur,
    currencyRate: CurrencyRate | undefined,
    includeProjectColumns: boolean
): number {
    let total = meurToEur(values['MTP+1'] ?? 0, currencyRate, 'new1')
        + meurToEur(values['MTP+2'] ?? 0, currencyRate, 'new2')
        + meurToEur(values['MTP+3'] ?? 0, currencyRate, 'new3');

    if (includeProjectColumns) {
        total += meurToEur(values.ff ?? 0, currencyRate, 'after')
            + meurToEur(values.previousYears ?? 0, currencyRate, 'forecast');
    }

    return total;
}
